<template>
  <router-view />
</template>

<script>
export default {
  name: "Wakaf",
};
</script>
